class ProductForm extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback () {
    this.qntyinput = this.querySelector('[data-qty="value"]');
    this.addToCartBtn = this.querySelector('.js-add-to-cart');
    this.variantId = this.addToCartBtn.dataset.variantId;

    this._onAddToCart = this._onAddToCart.bind(this);
    this.addToCartBtn.addEventListener('click', this._onAddToCart);
  }

  disconnectedCallback() {
    this.addToCartBtn.removeEventListener('click', this._onAddToCart);
  }

  externalAddToCart() {
    this._onAddToCart(new Event('instant-add'));
  }

  async _onAddToCart (e) {
    e.preventDefault();

    const quantity = parseInt(this.qntyinput.value) || 1;
    const id = this.variantId;

    if (!id) {
      console.error('❌ Missing variant ID');
      return;
    }

    let formData = {
      items: [
        { id, quantity }
      ],
      sections: 'cart-drawer'
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Failed to add to cart');
      const data = await response.json();

      console.log(data);

      document.documentElement.dispatchEvent(new CustomEvent("cart:rerender", 
        { detail: data, bubbles: true }
      ));

      console.log('✅ Added to cart:', data);
    } catch (error) {
      console.error('❌ Add to cart failed:', error);
    }
  }
}

customElements.define('product-form', ProductForm);


class CustomCartDrawer extends HTMLElement {
  constructor () {
    super();

    this.cartWrapper = this.closest('.cart-wrapper');
    this.cartOpen = document.querySelector('#cart-open');
    this.cartClosers = document.querySelectorAll('.cart-closer');
    this.cartCounter = document.getElementById('cartCounter');
  }

  connectedCallback () {
    this.cartOpen.addEventListener('click', this.openDrawer.bind(this));
    this.cartClosers.forEach((cartClose) => {
      cartClose.addEventListener('click', this.closeDrawer.bind(this));
    });

    document.addEventListener("cart:rerender", this.cartRerender.bind(this));
  }

  disconnectedCallback () {

  }

  handleOpen (event) {
    event.preventDefault();

    this.openDrawer();
  }

  openDrawer () {
    this.cartWrapper.classList.add('is--open');
  }

  closeDrawer () {
    this.cartWrapper.classList.remove('is--open');
  }

  get isDrawerOpen () {
    return this.cartWrapper.classList.contains('is--open');
  }

  cartRerender (e) {
    const newHTML = e.detail.sections["cart-drawer"];

    const doc = new DOMParser().parseFromString(newHTML, 'text/html');

    this.cartCounter.textContent = doc.querySelector('cart-drawer').dataset.totalQuantity;

    this.replaceWith(doc.querySelector('cart-drawer'));

    if (!this.isDrawerOpen) {
      this.openDrawer();
    }
  }
}

customElements.define('cart-drawer', CustomCartDrawer);

class QuantityControls extends HTMLElement {
  connectedCallback () {
    this.decreaseButton = this.querySelector('[data-qty="decrease"]');
    this.increaseButton = this.querySelector('[data-qty="increase"]');
    this.valueInput = this.querySelector('[data-qty="value"]');

    if (this.decreaseButton && this.increaseButton && this.valueInput) {
      this.decreaseButton.addEventListener('click', () => {
        this.updateQuantity(this.valueInput, 'decrease');
      });
      this.increaseButton.addEventListener('click', () => {
        this.updateQuantity(this.valueInput, 'increase');
      });
    }
  }

  updateQuantity(inputElement, action) {
    let currentValue = parseInt(inputElement.value) || 0;
    const minValue = parseInt(inputElement.getAttribute('min')) || 1;
    if (action === 'increase') {
        currentValue += 1;
    } else if (action === 'decrease') {
        if (currentValue > minValue) {
        currentValue -= 1;
        }
    }
    inputElement.value = currentValue;
  }
}

customElements.define('quantity-control', QuantityControls);


class CartActions extends HTMLElement {
  connectedCallback () {
    this.decreaseButton = this.querySelector('[data-qty="decrease"]');
    this.increaseButton = this.querySelector('[data-qty="increase"]');
    this.removeButton = this.querySelector('.is--remove');
    this.valueInput = this.querySelector('[data-qty="value"]');

    if (this.decreaseButton && this.increaseButton && this.valueInput) {
      this.decreaseButton.addEventListener('click', () => {
        this.updateQuantity(this.valueInput, 'decrease');
      });
      this.increaseButton.addEventListener('click', () => {
        this.updateQuantity(this.valueInput, 'increase');
      });
    }
    
    if (this.removeButton) {
      this.removeButton.addEventListener('click', this.handleRemove.bind(this));
    }
  }

  updateQuantity(inputElement, action) {
    let currentValue = parseInt(inputElement.value) || 0;
    const minValue = parseInt(inputElement.getAttribute('min')) || 1;
    if (action === 'increase') {
        currentValue += 1;
    } else if (action === 'decrease') {
        if (currentValue > minValue) {
        currentValue -= 1;
        }
    }
    inputElement.value = currentValue;

    this.handleChange(this.valueInput.value);
  }

  handleRemove () {
    this.handleChange(0);
  }

  async handleChange (quantity) {
    const formData = {
      'line': this.dataset.line,
      'quantity': quantity,
      'sections': "cart-drawer"
    }

    console.log(formData);

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Failed to add to cart');
      const data = await response.json();

      console.log(data);

      document.documentElement.dispatchEvent(new CustomEvent("cart:rerender", 
        { detail: data, bubbles: true }
      ))

      console.log('✅ Added to cart:', data);
    } catch (error) {
      console.error('❌ Add to cart failed:', error);
    }
  }
}

customElements.define('cart-actions', CartActions);